export const NODE_ENV = process.env.NODE_ENV;
export const ASSERT_MANAGEMENT_API_ENDPOINT =
  process.env.ASSERT_MANAGEMENT_API_ENDPOINT;
export const ADD_QUESTIONS_API_ENDPOINT = `${process.env.ASSERT_MANAGEMENT_API_ENDPOINT}/ABC`;
export const REACT_APP_AUTHENTICATE_TOKEN_NAME =
  process.env.REACT_APP_AUTHENTICATE_TOKEN_NAME;
export const REACT_APP_USER_ID_COOKIE_NAME = process.env.REACT_APP_USER_ID_COOKIE_NAME;
export const REACT_APP_USER_DETAILS_COOKIE_NAME = process.env.REACT_APP_USER_DETAILS_COOKIE_NAME;
export const REACT_APP_DOMAIN = process.env.REACT_APP_DOMAIN;
export const REACT_APP_TENANT_ID = process.env.REACT_APP_TENANT_ID;
export const CMS_API_ENDPOINT = process.env.CMS_API_ENDPOINT;
export const ASSET_MANAGEMENT_ENDPOINT = process.env.ASSET_MANAGEMENT_ENDPOINT;
export const REACT_APP_LOGIN_GATEWAY_API_ENDPOINT =
  process.env.REACT_APP_LOGIN_GATEWAY_API_ENDPOINT;
export const UAM_API_ENDPOINT = process.env.UAM_API_ENDPOINT;
export const REACT_APP_MDS_API_URL = process.env.REACT_APP_MDS_API_URL;
export const SIDEBAR_DRAWER_WIDTH = 240;
export const ISD_CODE = "+91";
export const ISD_CODE_PHONE_LENGTH = {
  "+973": 8,
  "+91": 10,
  "+965": 8,
  "+974": 8,
  "+968": 8,
  "+966": 9,
  "+971": 9,
  "+1": 10,
};
export const SELECT_OPTION_FALLBACK_LABEL = {
  CURRENCY: "Currency",
  TIMEZONE: "Timezone",
  ISD: "ISD",
};
export const MAX_TAX_REGISTRATION_NUMBER_LENGTH = 50;
export const CONTACT_PHONE_DIGITS_PATTERN = /^\d+$/;
export const CONTACT_VALIDATION_MESSAGES = {
  ISD_REQUIRED_WITH_PHONE: "ISD code is required when phone is provided",
  PHONE_REQUIRED_WITH_ISD: "Phone number is required when ISD code is provided",
  INVALID_ISD: "Invalid ISD code",
  INVALID_PHONE: "Enter a valid phone number",
  PHONE_LENGTH: (length) => `Phone number must be ${length} digits`,
};
export const ADDRESS_VALIDATION_MESSAGES = {
  LINE_1_REQUIRED: "Address Line 1 is required",
  CITY_REQUIRED: "City is required",
  DISTRICT_REQUIRED: "District is required",
  STATE_REQUIRED: "State is required",
  AREA_REQUIRED: "Area is required",
  PIN_REQUIRED: "Pin code is required",
  PIN_INVALID: "Invalid pin code",
};

export const EMPTY_CONTACT = {
  name: "",
  designation: "",
  phone: "",
  isdCode: "",
};

export const EMPTY_ADDRESS = {
  addressLine1: "",
  addressLine2: "",
  street: "",
  city: "",
  district: "",
  districtId: "",
  state: "",
  stateId: "",
  area: "",
  pinCode: "",
};

export const TENANT_FORM_FIELDS = {
  COUNTRY_ID: "countryId",
  CURRENCY_IDS: "currencyIds",
  TIMEZONE_IDS: "timezoneIds",
  GSTIN: "gstin",
  TAX_REGISTRATION_NUMBER: "taxRegistrationNumber",
  CONTACT_PHONE: "contact.phone",
  CONTACT_ISD_CODE: "contact.isdCode",
  ADDRESS_STATE: "address.state",
  ADDRESS_STATE_ID: "address.stateId",
  ADDRESS_DISTRICT: "address.district",
  ADDRESS_DISTRICT_ID: "address.districtId",
  ADDRESS_AREA: "address.area",
  ADDRESS_PIN_CODE: "address.pinCode",
};

export const CONTACT_FIELD_KEYS = {
  ISD_CODE: "isdCode",
  PHONE: "phone",
};

export const YUP_REQUIRED_TEST_SUFFIX = "-required";

export const NON_DIGIT_PATTERN = /\D/g;

export const INDIA_STATE_DISTRICT_FORM_FIELDS = [
  TENANT_FORM_FIELDS.ADDRESS_STATE,
  TENANT_FORM_FIELDS.ADDRESS_STATE_ID,
  TENANT_FORM_FIELDS.ADDRESS_DISTRICT,
  TENANT_FORM_FIELDS.ADDRESS_DISTRICT_ID,
];

export const ADDRESS_RESET_ON_COUNTRY_CHANGE_FIELDS = [
  ...INDIA_STATE_DISTRICT_FORM_FIELDS,
  TENANT_FORM_FIELDS.ADDRESS_AREA,
  TENANT_FORM_FIELDS.ADDRESS_PIN_CODE,
];

export const ADDRESS_LOCATION_KEYS = {
  DISTRICT: "district",
  DISTRICT_ID: "districtId",
  STATE: "state",
  STATE_ID: "stateId",
};

export const SELECT_OPTION_ID_PATHS = [
  "id",
  "value",
  "currencyId",
  "currency_id",
  "timezoneId",
  "timezone_id",
  "isdCodeId",
  "isd_code_id",
  "isdCode",
  "isd_code",
  "currency.id",
  "timezone.id",
  "isdCode.id",
  "isd_code.id",
];

export const SELECT_OPTION_LABEL_PATHS = [
  "label",
  "displayName",
  "display_name",
  "name",
  "code",
  "currency.displayName",
  "currency.name",
  "currency.code",
  "timezone.displayName",
  "timezone.name",
  "timezone.code",
  "isdCode.displayName",
  "isdCode.name",
  "isdCode.code",
  "isd_code.displayName",
  "isd_code.name",
  "isd_code.code",
  "isdCode",
  "isd_code",
];

export const OBJECT_PATH_SEPARATOR = ".";
export const ISD_CODE_PREFIX = "+";
export const GSTIN_LENGTH = 15;
export const MIN_REQUIRED_SELECTION_COUNT = 1;

export const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export const GSTIN_PATTERN = /^[0-9A-Z]{15}$/;
export const TENANT_CODE_PATTERN = /^[A-Z0-9]+$/;
export const EMAIL_PATTERN = /\S+@\S+\.\S+/;
export const ISD_CODE_WITH_PLUS_PATTERN = /\+\d+/;

export const TENANT_VALIDATION_MESSAGES = {
  NAME_REQUIRED: "Tenant name is required",
  BRANCH_NAME_REQUIRED: "Branch name is required",
  VERTICAL_REQUIRED: "Vertical is required",
  VERTICAL_SELECT: "Please select a vertical",
  CODE_REQUIRED: "Code is required",
  CODE_FORMAT: "Code must be capital alphanumeric.",
  EMAIL_INVALID: "Invalid email",
  EMAIL_REQUIRED: "Email is required",
  COUNTRY_REQUIRED: "Country is required",
  COUNTRY_SELECT: "Please select a country",
  TIMEZONE_MIN: "Please select at least one timezone",
  TIMEZONE_REQUIRED: "Timezone is required",
  CURRENCY_MIN: "Please select at least one currency",
  CURRENCY_REQUIRED: "Currency is required",
  GRADE_MIN: "At least one grade is required",
  GSTIN_INVALID: "Invalid GSTIN format",
  CONTACT_INVALID: "Invalid contact details",
  TAX_REGISTRATION_MAX_LENGTH: (maxLength) =>
    `Tax registration number must be ${maxLength} characters or less`,
};

export const TENANT_YUP_TEST_NAMES = {
  ID_SELECTED: "id-selected",
  AMBASSADOR_EMAIL: "ambassador-email-validation",
  GSTIN: "is-valid-gstin",
  CONTACT_PHONE_ISD: "contact-phone-isd-validation",
  AREA_REQUIRED: "area-required",
  PIN_CODE: "pin-code-validation",
};

export const SUCCESS_REDIRECT_SNACKBAR_DELAY_MS = 3000;
export const SCHOOL_API_BASE_URL = `${REACT_APP_LOGIN_GATEWAY_API_ENDPOINT}/api/v2/school`;
export const UDISE_SCHOOL_MGMT_API_URL =
  process.env.REACT_APP_UDISE_SCHOOL_MGMT_API_URL;
export const ONEGENIUS_API_BASE_URL = process.env.REACT_APP_ONEGENIUS_API_URL;
export const TENANT_ID = "1";

export const PRODUCT_ID = "300";

export const CURRENCY_ID = 1;

export const UPLOADED_ONBOARDING_FILE_HISTORY_COLUMN = [
  { label: "File Name", field: "name" },
  { label: "Uploaded At", field: "uploadedAt" },
  { label: "Total Rows", field: "totalRows" },
  { label: "Error Rows", field: "errorRows" },
  { label: "Status", field: "status" },
  { label: "Download Processed File ", field: "downloadProcessedFile" },
];

export const GRADES = [
  { key: 1, label: "Grade 1", value: "1" },
  { key: 2, label: "Grade 2", value: "2" },
  { key: 3, label: "Grade 3", value: "3" },
  { key: 4, label: "Grade 4", value: "4" },
  { key: 5, label: "Grade 5", value: "5" },
  { key: 6, label: "Grade 6", value: "6" },
  { key: 7, label: "Grade 7", value: "7" },
  { key: 8, label: "Grade 8", value: "8" },
  { key: 9, label: "Grade 9", value: "9" },
  { key: 10, label: "Grade 10", value: "10" },
  { key: 11, label: "Grade 11", value: "11" },
  { key: 12, label: "Grade 12", value: "12" },
  { key: 13, label: "Grade 13", value: "13" },
];

export const TENANT_STATUS = {
  CREATED: "CREATED",
  PUBLISHED: "LIVE",
};

export const UPLOAD_HISTORY_COLUMNS = [
{ label:"File Name", field: "fileName" },
{ label: "Status", field: "status" },
{ label: "Uploaded At", field: "uploadedAt" },
{ label: "Download Processed File", field: "downloadProcessedFile" },
]
export const ZERO = 0;
export const ONE = 1;
export const TENANT_SCRIPT_ID = 1;
export const TENANT_PAGE_SIZE_OPTIONS = [10, 15, 25];

export const BRANCH_SCRIPT_ID = 2;

export const ONBOARDING_FILE_SCRIPT_ID = 17;
export const GENIUS_ONBOARDING_FILE_SCRIPT_ID = 23;
export const NON_IL_SCA_ONBOARDING_FILE_SCRIPT_ID = 29;
export const ONBOARDING_FILE_MODULE_ID = 4;
export const ONBOARDING_TABS = [
  {
    id: "user-onboarding",
    label: "School User Onboarding",
    scriptId: ONBOARDING_FILE_SCRIPT_ID,
    uploadTitle: "Upload School User Onboarding File",
    historyTitle: "School User Upload History",
    emptyStateLabel: "school user onboarding",
  },
  {
    id: "genius-user-onboarding",
    label: "Genius User Onboarding",
    scriptId: GENIUS_ONBOARDING_FILE_SCRIPT_ID,
    uploadTitle: "Upload Genius User Onboarding File",
    historyTitle: "Genius User Upload History",
    emptyStateLabel: "genius user onboarding",
  },
  {
    id: "non-il-sca-user-onboarding",
    label: "Non-IL-SCA User Onboarding",
    scriptId: NON_IL_SCA_ONBOARDING_FILE_SCRIPT_ID,
    uploadTitle: "Upload Non-IL-SCA User Onboarding File",
    historyTitle: "Non-IL-SCA User Upload History",
    emptyStateLabel: "non-il-sca user onboarding",
  },
];
export const ONBOARDING_HISTORY_PAGE_SIZE_OPTIONS = [10, 25, 50];
export const DEFAULT_ONBOARDING_PAGE_NUMBER = ONE;
export const DEFAULT_ONBOARDING_PAGE_SIZE =
  ONBOARDING_HISTORY_PAGE_SIZE_OPTIONS[ZERO];
export const DEFAULT_BRANCH_PAGE_NUMBER = 1;


export const FILE_UPLOAD_STATUS = {
  CREATED: 1,
  UPLOADED: 2,
  PROCESSED: 3,
};

export const ALLOWED_ROLES = ["CSADMIN","SUAD","CSSUPADM","LSA","MISTA","GLMR","SRMR","MGR","EXREP","GSCHP"];
export const SEARCH_BRANCH_BY_CODE = "code";
export const SEARCH_BRANCH_BY_NAME = "name";
export const BRANCH_PAGE_SIZE_OPTIONS = [10, 15, 25];
export const MIN_BRANCH_NAME_SEARCH_LENGTH = 3;
export const MIN_SCHOOL_NAME_SEARCH_LENGTH = 3;
export const DEBOUNCE_TIME_MS = 300;
export const SEARCH_VALIDATION_MESSAGES = {
  UDISE_INVALID: "UDISE code must be exactly 11 digits",
  SCHOOL_CODE_INVALID: "School code must be SCH followed by 8 digits",
  SCHOOL_NAME_MIN_LENGTH: `School name must be at least ${MIN_SCHOOL_NAME_SEARCH_LENGTH} characters`,
  SEARCH_VALUE_BLANK: "Search term cannot be empty or filled with spaces",
};
export const DEFAULT_PRODUCT_ID = "100";
export const DEFAULT_TENANT_ID = "99999";